<nav class="tb-bar">

  <a *ngFor="let t of tabs"
     [routerLink]="[t.ruta]"
     routerLinkActive="on"
     [routerLinkActiveOptions]="{ exact: true }">
    <span class="tb-ico"></span>
    {{ t.texto }}
  </a>

  <button (click)="abrirSheet()" [class.on]="sheetAbierto">
    <span class="tb-ico tb-dots"><i></i><i></i><i></i></span>
    Más
  </button>

</nav>

<!-- Sheet de "Más": las secciones menos frecuentes -->
<div class="tb-ov" *ngIf="sheetAbierto" (click)="cerrarSheet()"></div>

<div class="tb-sheet" *ngIf="sheetAbierto">
  <div class="tb-grab"></div>
  <h3>Mi cuenta</h3>

  <div class="tb-menu">
    <a *ngFor="let i of enSheet" [routerLink]="[i.ruta]" (click)="cerrarSheet()">
      {{ i.texto }}
    </a>

    <a [href]="urlPuppisClub" target="_blank" rel="noopener noreferrer" (click)="cerrarSheet()">
      Sobre Puppis Club
    </a>

    <button class="tb-salir" (click)="cerrarSheet(); cerrarSesion.emit()">
      Cerrar sesión
    </button>
  </div>
</div>
